import React, { useState, useMemo, useCallback, useRef } from 'react';
import { apiHolder, util, isElectron as inElectron, getIn18Text } from 'api';
import styles from './CustomEditKey.module.scss';
import IconCard from '@web-common/components/UI/IconCard';
import KeySwiftInput from '@web-mail/common/components/KeySwiftInput/KeySwiftInput';
import useStateRef from '@web-mail/hooks/useStateRef';
import { systemIsMac } from '@web-common/utils/hotkey';
const systemApi = apiHolder.api.getSystemApi();
const isWebWmEntry = systemApi.isWebWmEntry();
const dataStoreApi = apiHolder.api.getDataStoreApi();
const isElectron = inElectron();
const separator = ' ';
const formatHotKey = (hotKey) => {
    if (hotKey) {
        const commandStr = util.getCommonTxt();
        const showKey = {
            command: commandStr,
            shift: systemIsMac() ? '⇧' : 'Shift',
            alt: systemIsMac() ? '⌥' : 'Alt',
            ctrl: systemIsMac() ? '⌃' : 'Ctrl',
            enter: systemIsMac() ? '↩' : 'Enter',
            up: '↑',
            down: '↓',
            del: '⌫',
        };
        if (typeof hotKey === 'string') {
            return showKey[hotKey.toLowerCase()] || hotKey;
        }
        if (hotKey && Array.isArray(hotKey)) {
            return hotKey.map(item => showKey[item.toLowerCase()] || item.toUpperCase()).join(separator);
        }
    }
    return '';
};
export const CustomEditKey = props => {
    const { value, formater = formatHotKey, onSuccess, onFail, editable = false, validate, onAdd } = props;
    const [isEdit, setIsEdit] = useState(false);
    const [tempValue, setTempValue] = useState([]);
    const tempValueRef = useStateRef(tempValue);
    const [conflict, setConflict] = useState(false);
    const conflictRef = useStateRef(conflict);
    const InputRef = useRef(null);
    const localValue = useMemo(() => {
        if (value) {
            if (typeof value === 'string') {
                return [value];
            }
            if (Array.isArray(value)) {
                if (value.every(item => typeof item === 'string')) {
                    return value;
                }
                if (value.every(item => Array.isArray(item)) && value.length) {
                    return value[0];
                }
            }
        }
        return [];
    }, [value]);
    const hkStr = useMemo(() => {
        return formater ? formater(localValue) : localValue.join('+');
    }, [localValue]);
    const reset = useCallback(() => {
        setIsEdit(false);
        setTempValue([]);
        setConflict(false);
    }, []);
    const valid = useCallback((pValue) => {
        if (formatHotKey(pValue) === formatHotKey(localValue)) {
            return true;
        }
        if (validate) {
            return validate(pValue);
        }
        return true;
    }, [localValue, validate]);
    const handleValidSuccess = useCallback((value) => {
        setConflict(false);
        onSuccess && onSuccess(localValue);
    }, [localValue]);
    const handleValidError = useCallback((value) => {
        setConflict(true);
        onFail && onFail(localValue);
    }, [localValue]);
    const handleEdit = useCallback(() => {
        setIsEdit(true);
        setTimeout(() => {
            var _a;
            (_a = InputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }, 10);
    }, []);
    const handleBlur = useCallback(() => {
        if (!conflictRef.current) {
            setIsEdit(false);
            onAdd && onAdd(tempValueRef.current);
        }
    }, []);
    const handleChange = useCallback((value) => {
        setTempValue(value);
    }, []);
    return (React.createElement("div", { className: "edit-hk-wrap" }, isEdit ? (React.createElement(KeySwiftInput, { ref: InputRef, value: localValue, valid: valid, onChange: handleChange, onValidSuccess: handleValidSuccess, onValidError: handleValidError, onBlur: handleBlur, clear: true })) : (React.createElement("div", { className: styles.editHkContent },
        hkStr ? React.createElement("div", { className: styles.editHkTxt }, hkStr) : React.createElement("div", { className: styles.emptyTxt }, getIn18Text('WEISHEZHIKUAIJIEJ')),
        React.createElement("div", { className: styles.editHkEditIcon, onClick: handleEdit },
            React.createElement(IconCard, { type: "hoverShuru" }))))));
};
export default CustomEditKey;
